import { Link } from 'react-router-dom';
import { Button, Icon } from '../components/ui.js';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-4 py-24 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-[var(--radius-lg)] bg-surface-3 text-ink-400">
        <Icon name="search" size={24} />
      </span>
      <div className="flex flex-col gap-1">
        <h1 className="font-display text-display-m text-ink-950">Pagina nu a fost găsită</h1>
        <p className="max-w-md text-body-s text-ink-600">
          Linkul este greșit sau pagina a fost mutată. Îți sugerăm să revii la ecranul principal.
        </p>
      </div>
      <Link to="/app">
        <Button icon={<Icon name="home" size={17} />}>Înapoi în dashboard</Button>
      </Link>
    </div>
  );
}
